'use client';

import { SmallLotPricingPackaging } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { InputField } from '@ravago/shared/radiance/components/input-field/components/InputField/InputField';
import { useTranslations } from '@ravago/shared/translations/client';

import { CombinedSuggestion } from '../../../utils/quote-pricing/combined-pricing.utils';

import { QuantitySuggestions } from './quantity-suggestions';

interface Props {
   value: string;
   suffix: string;
   suggestions: CombinedSuggestion[];
   smallLotPackaging?: SmallLotPricingPackaging;
   onChange: (value: string) => void;
   onSelect: (quantity: number, quoteLineId?: string) => void;
   error?: boolean;
   id?: string;
}

export const QuantitySelector = ({ value, suffix, suggestions, smallLotPackaging, onChange, onSelect, error, id }: Props) => {
   const translate = useTranslations();

   return (
      <Box direction="column" gap="sm">
         <Box direction="column" gap="xs">
            <InputField
               type="number"
               value={value}
               suffix={suffix}
               hideStepper
               error={error}
               onChange={onChange}
               id={id}
               label={translate('dynamic-product-block.small-lot.quantity')}
            />
            <QuantitySuggestions suggestions={suggestions} smallLotPackaging={smallLotPackaging} onSelect={onSelect} />
         </Box>
      </Box>
   );
};
